export class RequestedService {
  company: string;
  displayValue: string;
  value: string;
}
